<template>
    <v-dialog
        v-model="$props.params.addEditConfigurationDialog"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="closeAddEditConfigurationDialog()"
        @click:outside="closeAddEditConfigurationDialog()"
    >
        <v-card>
            <v-form @submit.prevent="processAddEditConfiguration()">
                <v-toolbar
                    color="primary"
                    dark
                    :class="dialogHeadingClasses()"
                >
                    <v-icon v-text="icons.mdiPlusCircleOutline" class="mr-3" v-if="$props.params.mode === 'add'"></v-icon>
                    <v-icon v-text="icons.mdiPencilCircleOutline" class="mr-3" v-else></v-icon>
                    <div v-if="$props.params.mode === 'add'" v-text="$gettext('Add Configuration')"></div>
                    <div v-else-if="$props.params.mode === 'edit'" v-text="$gettext('Edit Configuration')"></div>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddEditConfigurationDialog()" v-text="icons.mdiClose"></v-icon>
                    <v-icon @click.native.stop="processAddEditConfiguration()" v-text="icons.mdiContentSave"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-4">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    autofocus
                                    v-model="configurationName"
                                    :label="$gettext('Configuration Name')"
                                    outlined
                                    :error-messages="configurationNameErrors"
                                    @input="$v.configurationName.$touch()"
                                    @blur="$v.configurationName.$touch()"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeAddEditConfigurationDialog()" v-text="$gettext('Close')"></v-btn>
                    <v-btn color="primary" type="submit" v-text="$gettext('Save')"></v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>

import Vue from 'vue'

import Vuelidate from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinLodashPadStart from '@/mixins/lodash/MixinLodashPadStart'
import MixinApps from '@/mixins/apps/MixinApps'
import { mapWritableState } from 'pinia'
import { usePhonesStore } from '@/stores/PhonesStore'
import MixinVuelidate from '@/mixins/MixinVuelidate'

Vue.use(Vuelidate)
const mustHaveAnElement = (value) => value.length > 0

export default {
    components: { Snackbar },
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinLodashPadStart, MixinApps, MixinVuelidate],
    props: {
        params: {
            required: true,
            type: Object | Array,
        },
    },
    watch: {
        '$props.params.addEditConfigurationDialog' (value) {

            let self = this

            if (value) {
                self.fillInFields()
            } else {
                self.resetForm()
            }

        },
    },
    mounted () {

        let self = this
        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        self.fillInFields()

    },
    data () {
        return {
            configurationName: '',
        }
    },
    methods: {

        fillInFields () {

            let self = this

            if (self.$props.params.mode === 'add') {
                self.configurationName = ''
            } else if (self.$props.params.mode === 'edit') {
                self.configurationName = self.$props.params.inEditConfigurationName
            }

        },

        processAddEditConfiguration () {

            let self = this

            self.$v.$touch()

            if ( ! self.$v.$invalid) {

                if (self.$props.params.mode === 'add') {

                    let configurationToSave = {
                        key: self.configurationName,
                        value: {
                            'phone_model': {}
                        }
                    }

                    let configurationIndex = self.configurations.findIndex((configuration) => configuration.key === self.$props.params.currentSelectedConfiguration)

                    if (configurationIndex !== -1) {
                        self.configurations.splice(configurationIndex + 1, 0, configurationToSave)
                    } else {
                        self.configurations.push(configurationToSave)
                    }

                    self.$parent.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Configuration %{ configuration } created successfully.'), { configuration: self.configurationName }))
                    self.$emit('selectTheConfigurationAdded', self.configurationName)

                } else if (self.$props.params.mode === 'edit') {

                    let configurationIndex = self.configurations.findIndex((configuration) => configuration.key === self.$props.params.inEditConfigurationName)

                    self.configurations[configurationIndex].key = self.configurationName
                    self.$parent.$refs.snackbar.showSnackbar(self.$gettext('Configuration name updated successfully'))

                }

                self.closeAddEditConfigurationDialog()

            }

        },
        closeAddEditConfigurationDialog () {
            let self = this
            self.$parent.closeDialog('addEditConfigurationDialog')
        },
        resetForm () {
            let self = this
            self.$v.$reset()
            self.configurationName = ''
        },
    },
    computed: {

        configurationNameErrors () {
            const errors = []
            if ( ! this.$v.configurationName.$dirty) return errors
            ! this.$v.configurationName.required && errors.push(this.$gettext('Please provide the configuration name.'))
            ! this.$v.configurationName.isUnique && errors.push(this.$gettext('We already have a configuration with this name.'))

            return errors
        },

        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
        }),

    },
    validations: {
        configurationName: {
            required,
            async isUnique (value, vm) {
                let allowedValue = vm.params.mode === 'edit' ? vm.$props.params.inEditConfigurationName : null
                return await this.vuelidateIsUniqueForKeyValueType(value, this.configurations, allowedValue)
            }
        }
    }
}
</script>
